import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PreferenceService } from "../../services/preference.service";
import { EmailService } from "../../services/email.service";
import { Subject } from 'rxjs';
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { DeliveryClosureV3Component } from "../delivery-closure-v3/delivery-closure-v3.component";

@Component({
  selector: "app-multiple-pharmacies",
  templateUrl: "./multiple-pharmacies.component.html",
  styleUrls: ["./multiple-pharmacies.component.sass"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiplePharmaciesComponent implements OnInit {

  subject = new Subject();
  @ViewChild("contentConfirmation", { static: false }) contentConf: ElementRef;
  @ViewChild("contentError", { static: false }) contentErr: ElementRef;
  private selectedAll: any;

  // form: FormGroup
  form: any;

  @Output() OnDateSelected = new EventEmitter<string>();
  @Output() OnCancel = new EventEmitter<any>();
  //@Output() OnCancelok = new EventEmitter();

  @Input() closureDates: string;
  @Input() addedDates: string;
  @Input() removedDates: string;
  @Input() updatedPharmacyKey: string;
  @Input() updatedPharmacyName: String;

  //global variable to capture apiresponse
  apiresponse: boolean = false;
  acctsData = [];
  updatedDataAccts = [];
  historyDatesArray = [];


  pharmNames = [];
  currentUserEmail;
  hibeAddEmailBtn = true;
  addingEmail = false;
  additionalEmails;
  showNextButton = false;

  isCheckBoxChecked = true;

  tempAddedDates = [];
  tempRemovedDates = [];

  pharmAccounts = [];
  preference;

  pharmAccountsSelected;
  pharmNameSelected;
  canUpdateAccountPreference: Boolean = true


  private currentClosureDates: string;
  currentAddedDates;
  currentRemovedDates;

  userId;
  acctPrefs = [];

  firstName;
  email;
  track;

  message;

  // Variables for ASC/DSC sorting of Name and Acct Number
  nameToggle = true;
  accountToggle = true;
  activeField = "name";
  // nameIcon = "assets/static/icons/arrow-up-square.svg#asset"
  nameIcon = "arrow-up";
  // accountIcon = "assets/static/icons/arrow-up-square.svg#asset"
  accountIcon = "arrow-up";
  selectedYear
  // Variables for search functionality
  search: string;
  hideEle = {};
  allSelected: Boolean = false;
  searchClicked: Boolean = false;
  noSearchElement: Boolean = false;
  removedClosures;

  // Selected data
  selectedAcctData = [];

  constructor(
    private prefService: PreferenceService,
    private modalService: NgbModal,
    private EmailService: EmailService,
    private fb: FormBuilder,
    private all: DeliveryClosureV3Component
  ) { }

  ngOnInit(): void {
    this.pharmAccountsSelected = [];
    this.pharmNameSelected = [];

    this.form = new FormGroup({
      pharmacyAccts: new FormArray([]),
    });

    this.buildAccountsData();
    this.buildFormArray();
  }

  emailsForm = this.fb.group({
    emails: this.fb.array([this.fb.control("", [Validators.email])]),
  });

  buildDataFromSessionStorage() {
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));

    let currentShipTos = this.sortShipATos(
      this.checkForAliasIsBlank(apiData.shipTos)
    );

    this.userId = apiData.id;
    this.firstName = apiData.firstName;
    this.email = apiData.email;

    for (let i = 0; i < currentShipTos.length; i++) {
      this.pharmAccounts.push(currentShipTos[i].id);

      this.pharmNames.push(currentShipTos[i].name);
    }
  }

  buildFormArray() {
    let data = this.acctsData;

    if (data.length > 0) {
      for (let x in data) {
        this.form.get("pharmacyAccts").push(
          new FormGroup({
            name: new FormControl(data[x].name, [Validators.required]),
            acctNumber: new FormControl(data[x].acctNumber, [
              Validators.required,
            ]),
            // address: new FormControl(data[x].address, [Validators.required]),
            address1: new FormControl(data[x].address1, [Validators.required]),
            address2: new FormControl(data[x].address2, [Validators.required]),
            address3: new FormControl(data[x].address3, [Validators.required]),
            isSelected: new FormControl(data[x].isSelected),
          })
        );
      }
    }
  }

  handleSelectAll() {
    if (!this.allSelected) {
      this.form.get("pharmacyAccts").controls.map((value) => {
        if (!this.hideEle[value.value.acctNumber]) {
          value.get("isSelected").setValue(true);
        }
      });
      this.allSelected = true;
    } else {
      this.form.get("pharmacyAccts").controls.map((value) => {
        if (!this.hideEle[value.value.acctNumber]) {
          value.get("isSelected").setValue(false);
        }
      });
      this.allSelected = false;
    }
  }

  buildAccountsData() {
    this.buildDataFromSessionStorage();

    let sortedShipTos = JSON.parse(sessionStorage.getItem("sortedShipTos"));
    let shipToIndex = parseInt(sessionStorage.getItem("shiptoIndex"));
    let updatedPharmacy = sortedShipTos.splice(shipToIndex, 1)[0]; // Remove current pharmacy from array
    sortedShipTos.unshift(updatedPharmacy); // Put current pharmacy at beginning

    sortedShipTos.forEach((account) => {
      let acctNum = account.dc.toString() + "-" + account.customer.toString();

      let acctData = {
        acctNumber: acctNum,
        name: account.name,
        address1: account.address1,
        address2: account.address2,
        address3: account.address3,
        isSelected: updatedPharmacy.name === account.name ? true : false,
      };

      this.acctsData.push(acctData);
      this.updatedDataAccts.push(acctData);
    });
  }

  get submitIsDisabled() {
    return !this.form
      .get("pharmacyAccts")
      .controls.find((v) => v.value.isSelected);
  }


  submit() {
    let email;
    this.currentUserEmail = this.getUserEmailFromSessionStorage();

    if (
      this.getUserEmailFromSessionStorage() ===
      "chris.donovan@cardinalhealth.com"
    ) {
      email = "edmccormic@gmail.com";
    } else {
      email = this.getUserEmailFromSessionStorage();
    }

    const selectedData = this.form.value.pharmacyAccts.filter((item) => {
      if (item.isSelected === true) {
        return item;
      }
    });
    // Selected Name & acctNumber

    this.selectedAcctData = selectedData;

    this.updateWithMultiplePharmacies(email);
    this.modalService.dismissAll();
    // this.modalService.open(this.contentConf);
  }

  dismissModal() {
    this.modalService.dismissAll();
    sessionStorage.removeItem("addedDates");
    sessionStorage.removeItem("removedDates");
  }

  updatePharmacyClosureDates(emails) {
    let emailStr = emails.join();

    this.updateWithMultiplePharmacies(emailStr, false);

    this.emailsForm.reset();
    this.form.reset();

    this.emailsForm = this.fb.group({
      emails: this.fb.array([], [Validators.email]),
    });

    this.emailsForm.markAsPristine();
    this.emailsForm.markAsUntouched();
    this.form.markAsPristine();
    this.form.markAsUntouched();

    this.modalService.dismissAll();
  }

  noEmailWithAcct() {
    this.modalService.dismissAll();
  }

  public getYears(dates) {
    let strYr = [];
    let dateArray = dates.split(",");

    dateArray.forEach((date) => {
      let dateStr = date.split("/");
      if (dateStr.length > 1) {
        strYr.push(dateStr[2].includes(":R") ? dateStr[2].split(":")[0] : dateStr[2]);
      }

    });
    let unqiYears = [...new Set(strYr)];
    return unqiYears;
  }

  updateWithMultiplePharmacies(email, canUpdateAccountPreference = true) {
    this.buildAccountsData();

    this.OnDateSelected.emit("updated");
    let selectedAcctIds = [];
    let selectedAcctNames = [];
    this.selectedAcctData.map((obj) => {
      selectedAcctNames.push(Object.values(obj)[0]);
      selectedAcctIds.push(Object.values(obj)[1]);
    });

    this.pharmAccountsSelected = selectedAcctIds;
    this.pharmNameSelected = selectedAcctNames;

    let uniqueYears = this.getYears(this.removedDates.toString())


    if (canUpdateAccountPreference) {
      this.prefService
        .updateAccountPrefsWithMultiplePharmacies(
          this.generateTransactionId(),
          this.userId,
          this.closureDates,
          this.pharmAccountsSelected,
          this.removedDates,
          // this.historyDatesArray
        )
        .subscribe(
          (response) => {

            this.apiresponse = false;
            //set global variable to true if Api response is values updated
            if (response == "Values Updated") {
              this.apiresponse = true;

            }
          },
          (error) => {
            this.modalService.open(this.contentErr);
          },

          () => {

            if (this.apiresponse) {
              this.modalService.open(this.contentConf);
            } else {
              console.log("Failed ", this.apiresponse);
            }
          }
        );
    }


    let cEmail = email;
    this.currentAddedDates = sessionStorage.getItem("addedDates");
    this.currentRemovedDates = sessionStorage.getItem("removedDates");

    // let selectedAcctIdsForEmail = [...selectedAcctIds, this.updatedPharmacyKey];
    // let selectedAcctNamesForEmail = [
    //   ...selectedAcctNames,
    //   this.updatedPharmacyName,
    // ];


    //Code changes for NE-4433
    let selectedAcctIdsForEmail = [...selectedAcctIds];
    let selectedAcctNamesForEmail = [
      ...selectedAcctNames
    ];

    // setTimeout due to asynchronous feature of typescript
    setTimeout(() => {
      //trigger email if global variable is true i.e no error in api response
      if (this.apiresponse == true) {
        this.EmailService.sendEmailWithMultipleAccounts(
          this.generateTransactionId(),
          this.userId,
          this.addedDates,
          this.removedDates,
          selectedAcctIdsForEmail,
          selectedAcctNamesForEmail,
          this.firstName,
          cEmail
        ).subscribe((response) => {
          this.pharmAccountsSelected = [];
          this.pharmNameSelected = [];
        });
      }
    }, 5000);

    this.modalService.dismissAll();
  }

  get emails() {
    return this.emailsForm.get("emails") as FormArray;
  }

  addEmail() {
    this.emails.push(this.fb.control(""));
  }

  addEmailBtn() {
    this.hibeAddEmailBtn = false;
    this.addingEmail = true;
  }

  cancel() {
    this.OnCancel.emit();
    this.modalService.dismissAll();
  }

  cancelOK() {
    this.prefService.sendClickEvent()
  }


  public generateTransactionId() {
    let transactionId =
      "account-" +
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);

    return transactionId;
  }

  getUserEmailFromSessionStorage() {
    let apiData = JSON.parse(sessionStorage.getItem("userAPIData"));
    let emailString = apiData.email;

    return emailString;
  }

  sortShipATos(shipTos) {
    return shipTos.sort((a, b) => {
      if (a.name === b.name) {
        if (a.dc === b.dc) {
          if (a.customer < b.customer) {
            return -1;
          }
          if (a.customer > b.customer) {
            return 1;
          }
          return 0;
        } else {
          if (a.dc < b.dc) {
            return -1;
          }
          if (a.dc > b.dc) {
            return 1;
          }
          return 0;
        }
      } else {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }
    });
  }

  sortFuncName(props) {
    var sortOrder = 1;
    if (props[0] === "-") {
      sortOrder = -1;
      props = props.substr(1);
    }
    return function (a, b) {
      var result =
        a.value.name < b.value.name ? -1 : a.value.name > b.value.name ? 1 : 0;
      return result * sortOrder;
    };
  }

  sortFuncAccNumber(props) {
    var sortOrder = 1;
    if (props[0] === "-") {
      sortOrder = -1;
      props = props.substr(1);
    }
    return function (a, b) {
      let i = 0;
      var result = 0;

      const tempA = a.value.acctNumber;
      const tempB = b.value.acctNumber;
      const aDCNum = parseInt(tempA.split("-")[0]);
      const aCustomerNum = parseInt(tempA.split("-")[1]);

      const bDCNum = parseInt(tempB.split("-")[0]);
      const bCustomerNum = parseInt(tempB.split("-")[1]);

      if (aDCNum > bDCNum) {
        result = 1;
      } else if (aDCNum < bDCNum) {
        result = -1;
      } else {
        if (aCustomerNum > bCustomerNum) {
          result = 1;
        } else if (aCustomerNum < bCustomerNum) {
          result = -1;
        } else {
          result = 0;
        }
      }
      return result * sortOrder;
    };
  }

  // Handle Name sort
  handleNameSort() {
    this.activeField = "name";
    if (this.nameToggle) {
      this.form.get("pharmacyAccts").controls.sort(this.sortFuncName("-name"));
      // this.nameIcon = "assets/static/icons/arrow-down-square.svg#asset";
      this.nameIcon = "arrow-down";
      this.nameToggle = false;
    } else {
      this.form.get("pharmacyAccts").controls.sort(this.sortFuncName("name"));
      // this.nameIcon = "assets/static/icons/arrow-up-square.svg#asset";
      this.nameIcon = "arrow-up";
      this.nameToggle = true;
    }
  }

  // Handle Account number sort
  handleAccountSort() {
    this.activeField = "acctNumber";
    if (this.accountToggle) {
      this.form
        .get("pharmacyAccts")
        .controls.sort(this.sortFuncAccNumber("-acctNumber"));
      // this.accountIcon = "assets/static/icons/arrow-down-square.svg#asset";
      this.accountIcon = "arrow-down";
      this.accountToggle = false;
    } else {
      this.form
        .get("pharmacyAccts")
        .controls.sort(this.sortFuncAccNumber("acctNumber"));
      // this.accountIcon = "assets/static/icons/arrow-up-square.svg#asset";
      this.accountIcon = "arrow-up";
      this.accountToggle = true;
    }
  }

  // Handle search
  handleSearch() {
    this.searchClicked = true;
    const searchTerm = this.search;

    // deselect select all
    this.form.get("pharmacyAccts").controls.map((value) => {
      value.get("isSelected").setValue(false);
    });
    this.allSelected = false;

    const len = this.form.value.pharmacyAccts.length;
    if (searchTerm && searchTerm.length > 0) {
      for (let i = 0; i < len; i++) {
        const val = this.form.value.pharmacyAccts[i];
        this.hideEle[val.acctNumber] = false;
        if (val && val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
        } else if (
          val &&
          val.address1.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
        } else if (
          val &&
          val.address2.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
        } else if (
          val &&
          val.address3.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
        } else if (val && val.acctNumber.includes(searchTerm.toLowerCase())) {
        } else {
          this.hideEle[val.acctNumber] = true;
        }
      }

      let trueCount = Object.values(this.hideEle).filter(
        (item) => item === true
      ).length;

      if (trueCount === len) {
        this.noSearchElement = true;
      } else {
        this.noSearchElement = false;
      }
    }
  }

  highlight(data) {
    return data.replace(new RegExp(this.search, "gi"), (match) => {
      return '<span class="highlightText">' + match + "</span>";
    });
  }

  handleInputClear() {
    if (this.search.length == 0) {
      this.searchClicked = false;
      Object.keys(this.hideEle).forEach((h) => {
        this.hideEle[h] = false;
      });
      this.noSearchElement = false;

      // deselect select all
      this.form.get("pharmacyAccts").controls.map((value) => {
        value.get("isSelected").setValue(false);
      });
      this.allSelected = false;
    }
  }

  checkForAliasIsBlank(shipTos) {
    let newShipTos = [];
    for (let i = 0; i < shipTos.length; i++) {
      let shipTosObject = {
        name: "",
        dc: "",
        customer: "",
        id: 0,
      };
      if (shipTos[i].alias !== "") {
        shipTosObject.name = shipTos[i].alias;
        shipTosObject.dc = shipTos[i].distributionCenter;
        shipTosObject.customer = shipTos[i].customerNumber;
        shipTosObject.id = shipTos[i].id;
      } else {
        shipTosObject.name = shipTos[i].name;
        shipTosObject.dc = shipTos[i].distributionCenter;
        shipTosObject.customer = shipTos[i].customerNumber;
        shipTosObject.id = shipTos[i].id;
      }
      newShipTos[i] = shipTosObject;
    }
    return newShipTos;
  }

  callAnalytics() {
    let dates: Array<string> = [];

    for(let i = 0; i < this.addedDates.length; i++) {
      this.form.controls.pharmacyAccts.value.forEach((t) => {
        if (t.isSelected) { 
          let x = t.acctNumber.split("-")[1] + ":" + this.addedDates[i];
          dates.push(x);
        }
      })
    }

    for(let i = 0; i < this.removedDates.length; i++) {
      this.form.controls.pharmacyAccts.value.forEach((t) => {
        if (t.isSelected) { 
          let x = t.acctNumber.split("-")[1] + ":" + this.removedDates[i] + ":R";
          dates.push(x);
        }
      })
    }

    window["pageData"].submitMulti = {
      submit_multi: 'Delivery Closure:submit multi',
      dates: dates
    };
    window["_satellite"].track("Event-Store-Closure-Global");
    window["_satellite"].track("Event-Store-Closure-Submit-Multi-Acct");
  }
}









